// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__hM538","header":"MessagesList_header__MpsHs","chat":"MessagesList_chat__295tn"};